<app-prizes-senetpro  *ngIf="isPartnerTypeSingleBalance(); else prizesInitial"></app-prizes-senetpro>

<ng-template #prizesInitial>
    <app-prizes ></app-prizes>
</ng-template>
